import React from 'react';
import './PolicyPage.css';

const TermsAndConditions: React.FC = () => (
  <main className="policy-page">
    <h1>Terms & Conditions</h1>
    <p className="policy-updated">Last updated: September 23, 2026</p>
    <p>Welcome to Gimbiya Value Store. By accessing or using our website or application, you agree to these Terms & Conditions.</p>
    <h2>1. Shopping and Orders</h2>
    <p>Product descriptions, prices, availability, and images are provided for shopping guidance and may change without prior notice. An order is subject to confirmation and product availability.</p>
    <h2>2. Prices and Payments</h2>
    <p>
      Prices are displayed in Nigerian Naira (₦). Shipping is free. A minimum
      order value of ₦15,000 is required to place an order. Online payments are
      processed through Paystack and may include the payment channels displayed
      during checkout.
    </p>
    <h2>3. Delivery</h2>
    <p>Our estimated delivery time is within 24 hours for Zaria and Kaduna, and 1–3 days for locations outside this area. Actual delivery may be affected by address accuracy, product availability, logistics, weather, public holidays, or other circumstances beyond our reasonable control.</p>
    <h2>4. Returns and Refunds</h2>
    <p>Returns and refunds are handled under our Shipping & Returns and Refund Policy pages. Eligibility depends on the item, its condition, the reason for return, proof of purchase, and any applicable exclusions.</p>
    <h2>5. Return Shipping</h2>
    <p>Unless Gimbiya Value Store confirms otherwise in writing, the buyer is responsible for return shipping costs. Such costs depend on prevailing market rates and the selected logistics provider.</p>
    <h2>6. Manufacturer Warranty</h2>
    <p>Where a product includes a manufacturer warranty, it is governed by the manufacturer's terms, duration, exclusions, and claim process. Gimbiya Value Store does not promise a universal warranty for every product.</p>
    <h2>7. Acceptable Use</h2>
    <p>You must provide accurate information, protect your account credentials, and avoid misuse of the website, payment process, chat service, or other store features.</p>
    <h2>8. Changes</h2>
    <p>We may update these terms when necessary. The latest version published on this page will apply to future use and orders, subject to applicable law.</p>
    <h2>9. Contact</h2>
    <p>Questions may be sent to <a href="mailto:hello@gimbiyastore.com">hello@gimbiyastore.com</a>.</p>
  </main>
);
export default TermsAndConditions;
